const BODY_CLASS = 'search-overlay-open';
const LABEL_CLASS = 'header-main__search-label';

class SearchOverlay {
	static instance = null;

	static init() {
		if (SearchOverlay.instance) return;

		const overlay = document.querySelector('[data-component="search-overlay"]');
		const button = document.querySelector('.header-main__search-btn');
		if (!overlay || !button) return;

		SearchOverlay.instance = new SearchOverlay(overlay, button);
	}

	constructor(overlay, button) {
		this.overlay = overlay;
		this.button = button;
		this.trigger = button.querySelector('.wp-block-button__link') || button;
		this.input = overlay.querySelector('.search-overlay__input');
		this.closeEls = overlay.querySelectorAll('[data-search-overlay-close]');

		this.ensureLabel();
		this.ensureAria();
		this.bindEvents();
	}

	ensureLabel() {
		if (this.trigger.querySelector(`.${LABEL_CLASS}`)) return;

		const text = this.trigger.textContent.trim() || 'Search';
		[...this.trigger.childNodes].forEach((node) => {
			if (node.nodeType === Node.TEXT_NODE) node.remove();
		});

		const label = document.createElement('span');
		label.className = LABEL_CLASS;
		label.textContent = text;
		this.trigger.appendChild(label);
	}

	ensureAria() {
		if (!this.trigger.hasAttribute('aria-label')) {
			this.trigger.setAttribute('aria-label', 'Search');
		}
		this.trigger.setAttribute('aria-expanded', 'false');
	}

	bindEvents() {
		this.trigger.addEventListener('click', this.onButtonClick, true);
		this.closeEls.forEach((el) => el.addEventListener('click', this.onCloseClick));
		document.addEventListener('keydown', this.onKeydown);
	}

	isOpen() {
		return this.overlay.classList.contains('is-open');
	}

	open() {
		if (this.isOpen()) return;

		this.overlay.classList.add('is-open');
		this.overlay.setAttribute('aria-hidden', 'false');
		this.button.classList.add('is-search-open');
		this.trigger.setAttribute('aria-expanded', 'true');
		document.body.classList.add(BODY_CLASS);

		window.requestAnimationFrame(() => this.input?.focus());
	}

	close() {
		if (!this.isOpen()) return;

		this.overlay.classList.remove('is-open');
		this.overlay.setAttribute('aria-hidden', 'true');
		this.button.classList.remove('is-search-open');
		this.trigger.setAttribute('aria-expanded', 'false');
		document.body.classList.remove(BODY_CLASS);

		this.trigger.focus();
	}

	onButtonClick = (event) => {
		event.preventDefault();
		event.stopImmediatePropagation();
		this.open();
	};

	onCloseClick = (event) => {
		event.preventDefault();
		this.close();
	};

	onKeydown = (event) => {
		if (event.key === 'Escape' && this.isOpen()) this.close();
	};
}

export default SearchOverlay;
